import { Container } from "react-bootstrap";
import NewsContent from "../../news_components/news_content/components/news_content";

const News = () => {
  return (
    <Container fluid className="p-0 header_white">
      <NewsContent />
    </Container>
  );
};
export default News;
